import type { StatsIntervalIds } from 'types/client/stats';

export const STATS_INTERVALS: { [key in StatsIntervalIds]: { title: string; start?: Date } } = {
  all: {
    title: 'StatsFilters.allTime',
  },
  oneMonth: {
    title: 'StatsFilters.oneMonth',
    start: getStartDateInPast(1),
  },
  threeMonths: {
    title: 'StatsFilters.threeMonths',
    start: getStartDateInPast(3),
  },
  sixMonths: {
    title: 'StatsFilters.sixMonths',
    start: getStartDateInPast(6),
  },
  oneYear: {
    title: 'StatsFilters.oneYear',
    start: getStartDateInPast(12),
  },
};

function getStartDateInPast(months: number): Date {
  const date = new Date();
  date.setMonth(date.getMonth() - months);
  return date;
}
